// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-hotel-brand-carousel_container__fLCjm","box":"roomstay-blog-hotel-brand-carousel_box__DnH1S"};